import axios from "axios";
const {REACT_APP_API_RET_BTQ_URL,REACT_APP_API_RET_BTQ_PARAMS} = process.env;

export class RetourBoutiqueService {
  retourBoutiqueNea() {
    return axios.get(REACT_APP_API_RET_BTQ_URL);
  }


  retourBoutiqueWithParams(numDemdtl, numCgos) {
      const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': 'true',
      };
      return axios.get(REACT_APP_API_RET_BTQ_PARAMS, {
        params: {
          numDemandeDetail: numDemdtl,
          numcgos: numCgos
        },
        headers: header,
        withCredentials: 'omit'
      });
    }
}
